/**
 * shared/crypto/atomic-wipe.ts
 *
 * Isomorphic atomicWipe helper. Matches server/crypto.ts and
 * client/src/lib/prf-key-derivation.ts semantics. Per Immutable Security
 * Rule #3: overwrite with random, then zero. Caller must null the
 * reference after calling.
 */

import { randomBytes } from "@noble/hashes/utils";

export function atomicWipe(buffer: Uint8Array): void {
  if (!buffer || buffer.length === 0) return;
  const random = randomBytes(buffer.length);
  buffer.set(random);
  buffer.fill(0);
}
